var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"target":"_blank","rel":"noopener noreferrer","href":_vm.downloadLink}},[_c('img',{attrs:{"src":_vm.downloadImage,"width":"160px"}})])}
var staticRenderFns = []

export { render, staticRenderFns }